var DashboardContainerController = require('./DashboardContainerController.js').default;
var DashboardController = require('../../../dashboard/DashboardController.js').default;
var AddNewWidgetController = require('./AddNewWidgetController.js').default;
var WidgetPropertyEditController = require('./WidgetPropertyEditController.js').default;
var SelectDataSourceDirective = require('./SelectDataSourceDirective.js');
var SetAsSecondDirective = require('./SetAsSecondDirective.js');
var WidgetDataDirective = require('./WidgetDataDirective.js');
var WidgetEventFormDirective = require('./WidgetEventFormDirective.js');
var AngularHelper = require('../../../src/angular/AngularHelper.js').default;
var PresetShareController = require('./PresetShareController.js');
var PresetConfigController = require('./PresetConfigController.js').default;
var WidgetPropertyReadonlyController = require('./WidgetPropertyReadonlyController.js');
var EmbedPresetShareController = require('./EmbedPresetShareController.js');
var WidgetDataSourceController = require('./WidgetDataSourceController.js').default;

var AngularMessageBusService = require('../../../src/angular/AngularMessageBusService.js').default;
var PresetListDirective = require('../../../script/directive/PresetList.js');

angular.module('app.newapi', [])
.service('serviceMessageBus', AngularMessageBusService)
.directive('presetList', PresetListDirective)
.config(AngularHelper.config())
.run(AngularHelper.run());

logpresso.directive('selectDatasource', SelectDataSourceDirective);
logpresso.directive('setAsSecond', SetAsSecondDirective);
logpresso.directive('widgetData', WidgetDataDirective);
logpresso.directive('widgetEventForm', WidgetEventFormDirective);

logpresso.controller('DashboardController', DashboardController);
logpresso.controller('AddNewWidgetController', AddNewWidgetController);
logpresso.controller('DashboardContainerController', DashboardContainerController);
logpresso.controller('WidgetPropertyEditController', WidgetPropertyEditController);
logpresso.controller('WidgetPropertyReadonlyController', WidgetPropertyReadonlyController);
logpresso.controller('EmbedPresetShareController', EmbedPresetShareController);
logpresso.controller('PresetShareController', PresetShareController);
logpresso.controller('PresetConfigController', PresetConfigController);
logpresso.controller('WidgetDataSourceController', WidgetDataSourceController);


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/app.entry.js